import { render } from "./EnbProduto02.vue?vue&type=template&id=6d19b52f&scoped=true"
import script from "./EnbProduto02.vue?vue&type=script&lang=js"
export * from "./EnbProduto02.vue?vue&type=script&lang=js"

import "./EnbProduto02.vue?vue&type=style&index=0&id=6d19b52f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d19b52f"]])

export default __exports__